module.exports = __webpack_public_path__ + "officialStatic/fonts/RWmMoKWR9v4ksMfaWd_JN9XLiaQ6DQ.9a85cfa.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font/RWmMoKWR9v4ksMfaWd_JN9XLiaQ6DQ.woff2
// module id = L0VX
// module chunks = 0